import './businessUnit.css';
import { Outlet } from 'react-router-dom';

const BusinessUnit = () => {
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
};

export default BusinessUnit;
